let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1x1kI")).then(() => parcelRequire('7dLLD'));